import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { t } from '@cyberint/common-utils';
import Icons from '../Icons';
import IconButton from '../IconButton';
import { InputHeights } from '../../utils/consts';
import { FileFormat, FileSelectorVariant } from './consts';
import * as S from './styled';

export const FileIconSelector = ({
  onChange,
  onError,
  disabled,
  width = '100%',
  height = InputHeights.MEDIUM,
  showName,
  loading,
  testId,
  placeholder,
  format,
  multiple,
  variant = FileSelectorVariant.ICON
}) => {
  const fileInputRef = useRef(null);
  const [selectedFile, setFile] = useState(null);

  const onChangeHandler = f => {
    onChange?.(f);
    setFile(f);
  };

  const iconClickHandler = () => {
    if (disabled) return;
    fileInputRef.current?.click();
  };

  const inputHandler = async event => {
    if (disabled) return;
    if (multiple) {
      // TODO - later
      // onChange(event.target.files);
    } else {
      const file = event.target.files[0];
      if (format === FileFormat.BINARY) {
        const fr = new FileReader();
        fr.onload = e => {
          const { lastModified, name, size, type } = file;
          const [, content] = e.target.result.split(',');
          onChangeHandler({ ...file, lastModified, name, size, type, content });
          fileInputRef.current.value = null;
        };
        fr.onerror = onError;
        fr.readAsDataURL(file);
      } else if (format === FileFormat.TEXT) {
        try {
          const result = await file.text();
          onChangeHandler({ ...file, content: result });
        } catch (e) {
          onError?.(e);
        }
      } else {
        onChangeHandler(file);
        fileInputRef.current.value = null;
      }
    }
  };

  return (
    <S.UploadIconWrapper $width={width} $height={height}>
      {variant === FileSelectorVariant.ICON_BUTTON ? (
        <IconButton icon={Icons.Upload} size={16} onClick={iconClickHandler} disabled={disabled} testId={testId} />
      ) : (
        <Icons.Upload size={16} onClick={iconClickHandler} disabled={disabled} data-testid={testId} />
      )}
      {loading && (
        <S.LoadingIcon size={12} color="var(--button-loading-icon-color)" data-testid={`${testId}-loading`} rotate />
      )}
      {showName && (
        <S.FileNameWrapper $empty={!selectedFile?.name} data-testid={`${testId}-fileName`}>
          {selectedFile?.name || placeholder || t('common.selectFile')}
        </S.FileNameWrapper>
      )}
      <input
        type="file"
        className="dsc-hidden-file-input"
        ref={fileInputRef}
        placeholder={placeholder}
        onChange={inputHandler}
        data-testid={`${testId}-hidden-input`}
      />
    </S.UploadIconWrapper>
  );
};

FileIconSelector.propTypes = {
  onChange: PropTypes.func.isRequired,
  onError: PropTypes.func,
  height: PropTypes.oneOf(['LARGE', 'MEDIUM', 'SMALL', 'TINY', PropTypes.string, PropTypes.number]),
  width: PropTypes.string,
  variant: PropTypes.oneOf(['ICON', 'ICON_BUTTON']),
  testId: PropTypes.string,
  placeholder: PropTypes.string,
  showName: PropTypes.bool,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  multiple: PropTypes.bool,
  format: PropTypes.oneOf(['BINARY', 'TEXT'])
};
